import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
// import TagManager from '@sooro-io/react-gtm-module'

// const GTM_ID = process.env.REACT_APP_GTM_ID;
// // const STATIC_NONCE = process.env.REACT_APP_NONCE;

// const tagManagerArgs = {
//   gtmId: GTM_ID,
//   // nonce: STATIC_NONCE,
//   // source: 'https://idv-gtm-server-side-tagging-a9cefhh0e8hhh6fw.eastasia-01.azurewebsites.net/gtm.js'
//   // source: 'http://localhost:8080/gtm.js'
// }

// TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
